(function () {
  var root = document.querySelector("[data-bwvv-cs]");
  if (!root) return;

  var toggle = root.querySelector("[data-bwvv-cs-toggle]");
  var panel = document.getElementById("BwvvCsPanel");
  if (!toggle || !panel) return;

  function isOpen() {
    return toggle.getAttribute("aria-expanded") === "true";
  }

  function setOpen(next) {
    toggle.setAttribute("aria-expanded", next ? "true" : "false");
    panel.hidden = !next;
    root.classList.toggle("is-open", next);
  }

  function close() {
    setOpen(false);
  }

  toggle.addEventListener("click", function (event) {
    event.stopPropagation();
    setOpen(!isOpen());
  });

  document.addEventListener("click", function (event) {
    if (event.target.closest("[data-bwvv-cs-open]")) {
      event.preventDefault();
      setOpen(true);
      return;
    }
    if (!root.contains(event.target)) close();
  });

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") close();
  });

  function visible(el) {
    if (!el) return false;
    var style = window.getComputedStyle(el);
    if (style.display === "none" || style.visibility === "hidden" || style.opacity === "0") return false;
    var rect = el.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  }

  function cookieBanner() {
    return document.querySelector(
      "#shopify-pc-banner, .shopify-pc__banner, #shopify-consent-banner, [id*='shopify-pc-banner']"
    );
  }

  function updateClearance() {
    var raise = 0;
    var hide = false;
    var banner = cookieBanner();
    if (visible(banner)) {
      raise = Math.max(raise, Math.round(banner.getBoundingClientRect().height) + 12);
    }

    var fab = toggle.getBoundingClientRect();
    var danger = {
      left: fab.left - 12,
      right: fab.right + 12,
      top: window.innerHeight - 140,
      bottom: window.innerHeight,
    };

    document.querySelectorAll('form button[type="submit"], form input[type="submit"]').forEach(function (btn) {
      if (!visible(btn)) return;
      var rect = btn.getBoundingClientRect();
      var overlap =
        rect.right > danger.left &&
        rect.left < danger.right &&
        rect.bottom > danger.top &&
        rect.top < danger.bottom;
      if (overlap) hide = true;
    });

    root.classList.toggle("is-hidden", hide);
    root.style.setProperty("--bwvv-cs-raise", raise + "px");
  }

  var timer = null;
  function schedule() {
    window.clearTimeout(timer);
    timer = window.setTimeout(updateClearance, 80);
  }

  window.addEventListener("scroll", schedule, { passive: true });
  window.addEventListener("resize", schedule);
  document.addEventListener("shopify:section:load", schedule);
  if (window.MutationObserver) {
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  }
  updateClearance();
})();

